import {createListenerMiddleware} from '@reduxjs/toolkit';

// Create the middleware
const listenerMiddleware = createListenerMiddleware();

export default listenerMiddleware;
